"use strict";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { Text } from "../Text";
import * as styles from "./Spinner-css";
const spinnerSizes = /* @__PURE__ */ new Map([
  ["s", 18],
  ["m", 32],
  ["l", 64]
]);
const strokeWidths = /* @__PURE__ */ new Map([
  ["s", 2],
  ["m", 3],
  ["l", 4]
]);
export const Spinner = forwardRef(
  ({ size = "m", style, className, primary, message }, ref) => {
    const spinnerSize = spinnerSizes.get(size) || 32;
    const strokeWidth = strokeWidths.get(size) || 3;
    const radius = spinnerSize / 2;
    const offsetRadius = radius - strokeWidth / 2;
    const circumference = spinnerSize * Math.PI;
    return /* @__PURE__ */ React.createElement("div", { className: classNames(className, styles.container({ primary })), style }, /* @__PURE__ */ React.createElement(
      "svg",
      {
        className: styles.element,
        fill: "none",
        strokeWidth,
        width: spinnerSize,
        height: spinnerSize,
        strokeLinecap: "round",
        viewBox: `${radius} ${radius} ${spinnerSize} ${spinnerSize}`,
        ref
      },
      /* @__PURE__ */ React.createElement("circle", { className: styles.path, cx: spinnerSize, cy: spinnerSize, r: offsetRadius, strokeOpacity: 0.2 }),
      /* @__PURE__ */ React.createElement(
        "circle",
        {
          className: styles.path,
          cx: spinnerSize,
          cy: spinnerSize,
          r: offsetRadius,
          strokeDasharray: `${circumference / 4} ${circumference}`,
          strokeDashoffset: circumference
        }
      )
    ), !!message && /* @__PURE__ */ React.createElement(Text, { strong: true, size: "xs", align: "center", className: styles.message }, message));
  }
);
